import { Enrollment, EnrollmentDto } from '../enrollments/Enrollment';
import { utilities } from 'utils/utilities';

export enum NodePosition {
  Start = 'Start',
  End = 'End',
  Both = 'Both',
  Middle = 'Middle'
}

export interface NodeDto {
  nodeId: string;
  position: NodePosition;
  enrollmentDto: EnrollmentDto; // use EnrollmentDto if you want a stronger type
  nextNodeId?: string;
  index: number;
}

export class Node {
  id: string;
  position: NodePosition;
  enrollment: Enrollment;
  nextNode?: Node;
  index: number;

  constructor(enrollment: Enrollment, id?: string, position?: NodePosition) {
    this.id = id ? id : utilities.DEFAULT_GUID;
    // use provided position if given, otherwise default to Both
    this.position = position ?? NodePosition.Both;
    this.enrollment = enrollment;
    this.index = 1;
  }

  toDto(): NodeDto {
    console.log("Enrollment " + this.enrollment);

    if ((this.enrollment && typeof (this.enrollment as any).toDto === "function")){
      console.log("enrollment toDto function detected");
    }
    return {
      nodeId: this.id,
      position: this.position,
      enrollmentDto: (this.enrollment && typeof (this.enrollment as any).toDto === "function")
        ? (this.enrollment as any).toDto()   // subclass toDto() will be invoked here
        : { id: this.enrollment.id, enrollmentType: this.enrollment.type },
      nextNodeId: this.nextNode ? this.nextNode.id : undefined,
      index: this.index
    };
  }

  static fromDto(dto: Partial<NodeDto> & { enrollment?: Enrollment | EnrollmentDto | any }): Node {
    // If dto.enrollment is already an Enrollment instance, keep it.
    // Otherwise, rehydrate from the DTO using Enrollment.fromDto so methods like toDto() exist.
    //console.log("Node DTO " + JSON.stringify(dto));
    const enrollment =
      dto.enrollmentDto instanceof Enrollment
        ? dto.enrollmentDto
        : Enrollment.fromDto(dto.enrollmentDto as EnrollmentDto);

    const node = new Node(enrollment as any, dto.nodeId ?? utilities.DEFAULT_GUID, dto.position ?? NodePosition.Both);
    node.index = dto.index ?? 1;
    // nextNode linking should be handled by caller if needed
    return node;
  }
}

